import { render, staticRenderFns } from "./YoutubeVideo.vue?vue&type=template&id=726c45fa&scoped=true"
import script from "./YoutubeVideo.vue?vue&type=script&lang=js"
export * from "./YoutubeVideo.vue?vue&type=script&lang=js"
import style0 from "./YoutubeVideo.vue?vue&type=style&index=0&id=726c45fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c45fa",
  null
  
)

export default component.exports